<template>
  <div id="wrap" class="grid grid-cols-1">
    <div id="chart-year">
      <apexchart
        type="bar"
        height="500"
        ref="chart"
        :options="chartOptions"
        :series="series"
        @dataPointSelection="dataPointSelectionHandler"
      ></apexchart>
    </div>
    <div id="chart-quarter" v-show="seriesQuarter[0].data.length > 0">
      <apexchart
        type="bar"
        height="550"
        ref="chartQuarter"
        :options="chartOptionsQuarter"
        :series="seriesQuarter"
      ></apexchart>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";
import Requester from "@/views/agro_exporter/requesters/production/query_by_provider/show_process.js";

export default {
  name: "PRODReportingProcessShowReportsGraphicsCropSizesDynamic",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    organization_id: { required: true },
    harvest_process_id: { required: true },
    data: { required: true }
  },
  data() {
    return {
      seriesQuarter: [{ data: [] }],
      chartOptionsQuarter: {
        chart: {
          id: "barQuarter",
          height: 500,
          width: "100%",
          type: "bar",
          stacked: true
        },
        plotOptions: {
          bar: { columnWidth: "50%", horizontal: false }
        },
        legend: { show: false },
        grid: {
          yaxis: {
            lines: { show: true }
          },
          xaxis: {
            lines: { show: false }
          }
        },
        yaxis: {
          labels: {
            formatter: val => this.numberWithPrecision(val)
          }
        },
        title: {
          text: "Calibres por productor",
          offsetX: 10
        },
        tooltip: {
          x: {
            formatter: function (val, opts) {
              return opts.w.globals.seriesNames[opts.seriesIndex];
            }
          },
          y: {
            title: {
              show: false,
              formatter: function (val, opts) {
                return opts.w.globals.labels[opts.dataPointIndex];
              }
            },
            formatter: val => this.numberWithPrecision(val)
          }
        },
        dataLabels: {
          enabled: false,
          formatter: val => this.numberWithPrecision(val),
          style: { fontSize: "15px" },
          dropShadow: { enabled: true }
        },
        colors: []
      },
      crop_sizes_by_producer: {}
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          id: "barYear",
          height: 600,
          width: "100%",
          type: "bar"
        },
        plotOptions: {
          bar: {
            distributed: true,
            columnWidth: "50%",
            dataLabels: { position: "bottom" }
          }
        },
        dataLabels: {
          enabled: true,
          textAnchor: "start",
          style: { colors: ["#fff"], fontSize: "16px" },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex];
          },
          offsetX: 0,
          dropShadow: { enabled: true }
        },
        states: {
          normal: {
            filter: { type: "desaturate" }
          },
          active: {
            allowMultipleDataPointsSelection: true,
            filter: { type: "darken", value: 1 }
          }
        },
        tooltip: {
          x: { show: false },
          y: {
            title: {
              formatter: function (val, opts) {
                return opts.w.globals.labels[opts.dataPointIndex];
              }
            },
            formatter: val => this.numberWithPrecision(val)
          }
        },
        legend: { show: false },
        title: {
          text: "Calibres (Kg)",
          offsetX: 15,
          style: { fontSize: "20px" }
        },
        subtitle: {
          text: "(Haga Click en una barra para ver detalles)",
          offsetX: 15,
          style: { fontSize: "14px", color: "#888" }
        },
        yaxis: {
          labels: {
            show: true,
            formatter: val => this.numberWithPrecision(val)
          }
        },
        xaxis: {
          labels: { show: false }
        },
        colors: [
          "#ef4444",
          "#f97316",
          "#84cc16",
          "#10b981",
          "#3b82f6",
          "#a855f7",
          "#f43f5e",
          "#eab308"
        ]
      };
    },
    series() {
      return [
        {
          data: this.data.map(item => {
            return {
              x: item.x.crop_size,
              y: item.y,
              crop_size_id: item.x.crop_size_id
            };
          })
        }
      ];
    }
  },
  methods: {
    dataPointSelectionHandler: async function (_, chart, opts) {
      var quarterChartEl = document.querySelector("#chart-quarter");
      var yearChartEl = document.querySelector("#chart-year");

      if (opts.selectedDataPoints[0].length === 1) {
        if (quarterChartEl.classList.contains("active")) {
          this.updateQuarterChart(chart);
        } else {
          yearChartEl.classList.add("chart-quarter-activated");
          quarterChartEl.classList.add("active");
          this.updateQuarterChart(chart);
        }
      } else {
        this.updateQuarterChart(chart);
      }

      if (opts.selectedDataPoints[0].length === 0) {
        yearChartEl.classList.remove("chart-quarter-activated");
        quarterChartEl.classList.remove("active");
      }
    },
    async updateQuarterChart(source_chart) {
      var series = [];
      var seriesIndex = 0;
      var colors = [];
      if (source_chart.w.globals.selectedDataPoints[0]) {
        var selectedPoints = source_chart.w.globals.selectedDataPoints;
        for (var i = 0; i < selectedPoints[seriesIndex].length; i++) {
          var selectedIndex = selectedPoints[seriesIndex][i];
          var yearSeries = source_chart.w.config.series[seriesIndex];
          series.push({
            name: yearSeries.data[selectedIndex].x,
            data: await this.getDataByCropSizes(selectedIndex)
          });
          colors.push(source_chart.w.globals.colors[selectedIndex]);
        }
        if (series.length === 0) series = [{ data: [] }];
      }
      this.chartOptionsQuarter = {
        ...this.chartOptionsQuarter,
        colors: colors
      };
      this.seriesQuarter = series;
    },
    async getDataByCropSizes(dataPointIndex) {
      const s = this.crop_sizes_by_producer[dataPointIndex];

      // this.chartOptionsQuarter = {
      //   ...this.chartOptionsQuarter,
      //   colors: [w.globals.colors[dataPointIndex]]
      // };

      const series_data = this.series[0].data[dataPointIndex];
      if (s == undefined) {
        const res = await this.fetchCropSizesByProducer(
          series_data.crop_size_id
        );
        this.crop_sizes_by_producer[dataPointIndex] = res;
        // this.seriesQuarter = [{ name: series_data.x, data: res }];
        return res;
      } else {
        // this.seriesQuarter = [{ name: series_data.x, data: s }];
        return s;
      }
    },
    fetchCropSizesByProducer: async function (crop_size_id) {
      const response = await Requester.fetchCropSizesByProducer(
        this.organization_id,
        this.harvest_process_id,
        crop_size_id
      );
      return response.data;
    }
  }
};
</script>
